import script from "./PCPartHistoryPopup.vue?vue&type=script&setup=true&lang=js"
export * from "./PCPartHistoryPopup.vue?vue&type=script&setup=true&lang=js"

import "./PCPartHistoryPopup.vue?vue&type=style&index=0&id=23f6db4c&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-23f6db4c"]])

export default __exports__